// extracted by mini-css-extract-plugin
export default {"searchBar":"searchBar_searchBar__rYCQt","searchBar__icon":"searchBar_searchBar__icon__Rn6op","searchBar__input":"searchBar_searchBar__input__BXxkB"};